import React from "react";

function OurInstructors() {
  return <div>OurInstructors</div>;
}

export default OurInstructors;
